import { IUser } from "models/User";
import { DashboardPermissions } from "models/dashboard";
import { Dashboard, WorkspaceDashboard } from "models/workspace";

export const getDashboardPermissions = (
  dashboard: Dashboard | WorkspaceDashboard,
  user: Maybe<IUser>,
  isAtLeastPowerUser: boolean,
  canEditWorkspace?: boolean
): DashboardPermissions => {
  let viewable = false;
  let editable = false;
  let deletable = false;

  // The user can be absent here: popout/standalone routes are not gated on
  // `state.auth.user` (AppRouter.tsx), so they mount while the window is still
  // waiting for the cross-tab auth handshake, and the dashboard query can win
  // that race. Comparing an absent id directly would also make an ownerless
  // dashboard look owned (`undefined === undefined`), so require an id.
  const isOwner = !!user?.id && dashboard?.owner === user.id;

  switch (dashboard?.type) {
    case "Personal":
      viewable = isOwner;
      editable = isOwner;
      deletable = editable && canEditWorkspace;
      break;
    case "Shared":
      viewable = true;
      editable = isOwner || isAtLeastPowerUser;
      deletable = editable;
      break;
    case "Organization":
      viewable = true;
      editable = isAtLeastPowerUser;
      deletable = editable;
      break;
    case "System":
      viewable = true;
      editable = false;
      deletable = false;
      break;
  }

  return {
    canView: viewable,
    canEdit: editable,
    canDelete: deletable
  };
};
